import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import employee components (lazy-loaded for performance)
const EmployeesList = React.lazy(() => import("./EmployeesList"));
const NewEmployee = React.lazy(() => import("./NewEmployee"));
const EmployeeDetails = React.lazy(() => import("./EmployeeDetails"));

const employeesModuleConfig: ModuleConfig = {
    // Module Identity
    id: "employees",
    name: "Employee Management",
    description: "Manage employee records, HR information, and workforce data",
    version: "1.0.0",
    enabled: true,
    category: "hr",
    order: 3,
    icon: "👷",
    color: "#5A67D8",

    // Routes
    routes: [
        {
            path: "/employees",
            component: EmployeesList,
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER"]
        },
        {
            path: "/employees/new",
            component: NewEmployee,
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER"]
        },
        {
            path: "/employees/:id",
            component: EmployeeDetails,
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER", "HR_VIEWER"]
        },
        {
            path: "/employees/edit/:id",
            component: NewEmployee, // Reuse NewEmployee component for editing
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER"]
        }
    ],

    // Navigation
    navigation: [
        {
            label: "All Employees",
            path: "/employees",
            icon: "👥",
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER", "HR_VIEWER"]
        },
        {
            label: "Add Employee",
            path: "/employees/new",
            icon: "➕",
            permissions: ["ADMIN", "MANAGER", "HR_MANAGER"]
        }
    ],

    // Permissions
    permissions: {
        view: ["ADMIN", "MANAGER", "HR_MANAGER", "HR_VIEWER"],
        create: ["ADMIN", "MANAGER", "HR_MANAGER"],
        edit: ["ADMIN", "MANAGER", "HR_MANAGER"],
        delete: ["ADMIN", "HR_MANAGER"]
    },

    // Quick Actions
    quickActions: [
        {
            label: "Add Employee",
            path: "/employees/new",
            icon: "➕",
            description: "Register a new employee in the system"
        },
        {
            label: "View All",
            path: "/employees",
            icon: "👥",
            description: "View all employees"
        }
    ]
};

export default employeesModuleConfig;